<script lang="ts">
	import { Alert } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import {
		defaultTempFavPositions,
		isWallDisplay,
		real_id,
	} from 'src/helpers/interface_helpers';
	import { devices } from 'src/stores/lists/devices';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';
	import { getWallDisplayTemperatureSensorError } from './wall_display_thermostat_alerts';
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let status: {
		['temperature:0']?: { errors?: string[] };
		['thermostat:0']?: { current_C?: number; display_unit?: string };
	} | null = null;

	$: sensorError = getWallDisplayTemperatureSensorError(status);
	$: displayUnit = status?.['thermostat:0']?.display_unit === 'F' ? 'F' : 'C';
	$: tempFavPositions =
		(isWallDisplay(device?.type)
			? $devices[real_id(device.id)]?.temp_fav_positions
			: device?.temp_fav_positions) || defaultTempFavPositions(displayUnit);
	$: showFavPositionsAlert =
		!device?.shared && tempFavPositions?.filter((pos) => pos.active).length === 0;
	$: parentDeviceId = real_id(device?.id);
</script>

{#if sensorError.present}
	{#if sensorError.driverMissing}
		<Alert
			class="mb-s"
			type="danger"
			isHeadingBold
			heading={$format('alert_heading_wall_display_sensor_firmware', {
				default: 'Temperature sensor unavailable',
			})}
			message={$format('alert_message_wall_display_sensor_firmware', {
				default:
					'This firmware does not include the temperature sensor. Update the device firmware to restore temperature readings.',
			})}
			cta={device?.shared
				? undefined
				: {
						title: $format('title_update_firmware_update', {
							default: 'Update Firmware',
						}),
					}}
			on:cta_click={() => navigateToSetting(parentDeviceId, 'settings', 'firmware_version')}
		/>
	{:else}
		<Alert
			class="mb-s"
			type="danger"
			heading={$format('alert_danger_sensor_missing_wall_display', {
				default: 'Temperature sensor error detected.',
			})}
		/>
	{/if}
{/if}

{#if showFavPositionsAlert}
	<Alert
		class="mb-s"
		type="info"
		heading={$format('alert_info_heading_temp_fav_positions', {
			default: 'You can enable or disable temperature favorite positions from sensor settings',
		})}
		cta={{
			title: $format('button_enable_disable', {
				default: 'Enable/Disable',
			}),
		}}
		on:cta_click={() => {
			navigateToSetting(parentDeviceId, 'sensor_settings', 'temperature_favorite_positions');
		}}
	/>
{/if}
